module.exports = __webpack_public_path__ + "static/media/Shieldon_gaussian2.01ff6667.png";